import { SalaryIncomeFrequency } from "prisma/cm/client";

const frequencyAbbrevMap: Record<SalaryIncomeFrequency, string> = {
  [SalaryIncomeFrequency.YEARLY]: "yr",
  [SalaryIncomeFrequency.MONTHLY]: "mo",
  [SalaryIncomeFrequency.SEMI_MONTHLY]: "sm",
  [SalaryIncomeFrequency.BI_WEEKLY]: "bw",
  [SalaryIncomeFrequency.WEEKLY]: "wk",
  [SalaryIncomeFrequency.DAILY]: "day",
  [SalaryIncomeFrequency.HOURLY]: "hr",
  // Shouldn't use this one
  [SalaryIncomeFrequency.FIXED]: "",
};

export function getFrequencyAbbrev(frequency: SalaryIncomeFrequency) {
  return frequencyAbbrevMap[frequency];
}

export function formatCashAmountWithFrequency(
  amountStr: string,
  frequency?: SalaryIncomeFrequency | null,
) {
  if (frequency === SalaryIncomeFrequency.FIXED || !frequency) return amountStr;
  return `${amountStr} / ${getFrequencyAbbrev(frequency)}`;
}
